import React from "react";
import { Box, Tooltip } from "@mui/material";


import {
  moduleList,
  rolesArray,
  userDesignation,
  userTypes,
  editAccessOptions,
} from "../../constants/masterUserConstants";

const settingKeyInfo = [
  {
    key: "CertificateNumberByDatasheet",
    reason: "Certificate No change by date of callibration",
  },
  {
    key: "Datasheet Autoload",
    reason: "show Autoload button in Datasheet if value is true",
  },
  {
    key: "videoUpload",
    reason: "videoUpload button show in instrument",
  },
  {
    key: "CSRFS",
    reason: "show CSRF Form Button in srf",
  },
  {
    key: "Customer Annexure",
    reason: "show Customer Annexure Button in srf",
  },
  {
    key: "ClientsUser (global.js)",
    reason: "remove Client option role in usermaster",
  },
  {
    key: "SOPUpload",
    reason: "show button in certificatelist, instrument",
  },
  {
    key: "TrainingAndMasterCertificate",
    reason: "show button in usermaster , certificatelist, masterEQP",
  },
  {
    key: "TablePartition",
    reason: "show in instrument Checkbox",
  },
  {
    key: "CompanyList",
    reason: "add compnay list",
  },
  {
    key: "OfflineMode (global.js)",
    reason: "remove offline button in navbar",
  },
  {
    key: "locationTracking",
    reason: "(global js)datasheet list in action show button where open modal"
  },
  {
    key: "DucImages",
    reason: "show DucImages button in editInward"
  },
  {
    key: "Department Analytics (global.js)",
    reason: "show Department Analytics report"
  },
  {
    key: "chatBoatTawkKey",
    reason: "add chatboat api keyafter to/"
  },
  {
    key: "tableTemplateReferenceimgDatasheet",
    reason: "add to Image Upload option in table template"
  },
  {
    key: "Training Resources (global.js)",
    reason: "add Training Resources in sidebar"
  },
  {
    key: "tableTemplateComplianceStatus",
    reason: "show Compliance Status checkbox in Template"
  },
  {
    key: "Compliance Status",
    reason: "show Compliance Status in certificate"
  },
  {
    key: "ManualURL",
    reason: "ManualURL is false and if certificate clicked approved button then ulr last digit come from LASTULRNODIGIT setting"
  },
  {
    key: "LASTULRNODIGIT",
    reason: "enter last number where want in ulr if set 30 then come like this CC269523000000030F"
  },
  {
    key: "Failed Certificate Approval (user master access)",
    reason: "if give this access to user then he can approve certificates where if compliance status is failed"
  },
  {
    key: "Compliance Status Alert",
    reason: "When certificate approve then show alert or not"
  },
  {
    key: "CMCLocationMapping",
    reason: "in this location mapping use Lab(3) => 3:1 comapre 3 as 1"
  },
  {
    key: "letterHeadCompanyType",
    reason: "in certificate show dropdown where select letterhead img"
  },
  {
    key: "InvAndQutLetterHead",
    reason: "show compnay letterhead selection dropdown in invoice and quotation"
  },
  {
    key: "Master-Inout",
    reason: "if true then location 1 and 3 show all master and location 2 show only assigned and if false then show all masters"
  },
  {
    key: "AuditSRF",
    reason: "AuditSRF is true then show audit option in srflist and certificate list to show particular instrument audit"
  },
  {
    key: "FailedCertificateApproval (global.js)",
    reason: "remove Failed Certificate Approval option in edit access list from usermaster",
  },
  {
    key: "ETAutoload",
    reason: "ETAutoload is true then show make and model wise only jobNo and if false then add ranges and lc wise also jobNo",
  },
  {
    key: "ULRCertificateSRFDisabledDS",
    reason: "ULRCertificateSRFDisabledDS is true then in Datasheet Certificate, ULR No and SRF No can Edit if false then disabled",
  },
  {
    key: "emailOtpVerification",
    reason: "To add email OTP verification in login.",
  },
  {
    key: "autoStandardFilteration",
    reason: "If it's true, then no standard masters are displayed after filtering by standard ranges. If false, all standard masters are displayed.",
  },
  {
    key: "environmentalCheck",
    reason: "If environmentalCheck is true, then compare the start temperature, middle temperature, and end temperature — and do the same for humidity — with the datasheet’s discipline temperature and humidity.",
  },
  {
    key: "UULIMS",
    reason: "device registration login key genrate uuid",
  },
  {
    key: "m&d_ReadingsCopy",
    reason: "datasheet reading copy value to another column",
  },
  {
    key: "multiplecalibrationprocedure",
    reason: "datasheet and instuemnt show multiple procedure no add option",
  },
  {
    key: "certificateDatsheetPrint",
    reason: "show print option in certificate list to navigate datashhet print",
  },
  {
    key: "Decision Rule",
    reason: "show Decision Rule tbale in certificate and datasheet",
  },
  {
    key: "CertificateMasterLink",
    reason: "show clickable link in certificate standard table on instrument name",
  },
  {
    key: "DatasheetReadingsAudit",//this ls in global
    reason: "show Datasheet Readings Audit in certificate Audit",
  },
  {
    key: "ChallanGetPass",
    reason: "show Challan no formate when create challan no in gate pass e.g (BFI/YYYYMMDD/{no})",
  },
  {
    key: "DispatchChallanNo",
    reason: "show Challan no formate when create challan no in gate pass e.g (BFI/YYYYMMDD/{no})",
  },
  {
    key: "JobRestrinctionEng",
    reason: "if this true then datasheet edit button will block and last 7 days data check and last 2 days if job pending then not allow to edit new assigned jobs",
  },
  {
    key: "QREmailVerificationStop",
    reason: "if add in (global.js DISABLED_MODULES) then stop qr code email verification",
  },
  {
    key: "TaskAssignEmailCC",
    reason: "add in seeting using comma email then send that cc users (test@gmail, test1@gmail, test2@gmail)",
  },
  {
    key: "datasheetCalibratedUser",
    reason: "in seeting add after show dropdown in edit datasheet then selected user save in calibratedby",
  },
];

const DesignationTable = ({ tableName, tableimport }) => {
  if (!Array.isArray(tableimport)) {
    console.error(
      `Expected an array for tableimport, got: ${typeof tableimport}`
    );
    return null;
  }


  return (
    <div>
      <h5 style={{ textAlign: "left" }}>
        <b>{tableName}</b>
      </h5>
      <br />
      <table>
        <thead>
          <tr>
            <th style={{ padding: "3px" }}>ID</th>
            <th style={{ padding: "3px" }}>Name</th>
          </tr>
        </thead>
        <tbody>
          {tableimport.map((item) => (
            <tr key={item.id}>
              <td style={{ padding: "3px" }}>{item.id}</td>
              <td style={{ padding: "3px", textAlign: "left" }}>
                {item?.name}
                {item?.label}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AppInfo = () => {
  return (
    <Tooltip style={{ padding: "1rem" }}>
      <Box
        sx={{
          margin: "1rem",
          padding: "1.5rem 1rem",
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "0.5rem",
        }}
      >
        <DesignationTable tableName={"User Types"} tableimport={userTypes} />
        <DesignationTable tableName={"Roles"} tableimport={rolesArray} />
        <DesignationTable
          tableName={"User Designation"}
          tableimport={userDesignation}
        />
        <DesignationTable tableName={"Modules"} tableimport={moduleList} />
        <DesignationTable
          tableName={"Access Options"}
          tableimport={editAccessOptions}
        />
      </Box>
      <Box sx={{ margin: "1rem", padding: "0.5rem 1rem", }}>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ padding: "3px" }}>key</th>
              <th style={{ padding: "3px" }}>Reason</th>
            </tr>
          </thead>
          <tbody>
            {settingKeyInfo.map((item) => (
              <tr key={item.id}>
                <td style={{ padding: "3px", textAlign: "left" }}>
                  {item.key}
                </td>
                <td style={{ padding: "3px", textAlign: "left" }}>
                  {item?.reason}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <br />
    </Tooltip>
  );
};

export default AppInfo;
